const rankingItems = [
  { rank: 1, title: '星际迷航：新纪元', type: '科幻电影', hot: '1280万热度', trend: 'up', change: '+3' },
  { rank: 2, title: '长安十二时辰', type: '古装剧集', hot: '1156万热度', trend: 'up', change: '+1' },
  { rank: 3, title: '深海探秘', type: '纪录电影', hot: '982万热度', trend: 'up', change: '+5' },
  { rank: 4, title: '笑傲江湖之风云再起', type: '动作电影', hot: '867万热度', trend: 'down', change: '-2' },
  { rank: 5, title: '都市夜话', type: '情感剧集', hot: '754万热度', trend: 'new', change: 'NEW' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          <div className="lg:w-[360px] shrink-0">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-3 whitespace-nowrap">
              实时热度
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
              热门榜单
            </h2>
            <p className="text-sm text-foreground-500 leading-relaxed">
              基于全网搜索热度、播放量与用户讨论度综合排序，每日自动更新，反映最真实的观影风向。
            </p>
            <div className="mt-4 flex items-center gap-2 text-xs text-foreground-400">
              <span className="w-1.5 h-1.5 rounded-full bg-green-500" />
              更新于 10 分钟前
            </div>
          </div>

          <div className="flex-1">
            <div className="space-y-1">
              {rankingItems.map((item) => (
                <a
                  key={item.rank}
                  href="#media"
                  className="flex items-center gap-4 p-4 rounded-xl hover:bg-background-100 transition-colors cursor-pointer group"
                >
                  <div className={`w-10 h-10 flex items-center justify-center rounded-lg font-bold text-sm shrink-0 ${
                    item.rank === 1
                      ? 'bg-accent-500 text-white'
                      : item.rank === 2
                      ? 'bg-secondary-400 text-white'
                      : item.rank === 3
                      ? 'bg-primary-400 text-white'
                      : 'bg-background-200 text-foreground-500'
                  }`} style={{ fontFamily: 'var(--font-heading)' }}>
                    {item.rank}
                  </div>

                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                      {item.title}
                    </h3>
                    <span className="text-xs text-foreground-400">{item.type}</span>
                  </div>

                  <div className="text-right shrink-0">
                    <div className="text-sm font-semibold text-foreground-800">{item.hot}</div>
                    <span className={`text-xs font-medium whitespace-nowrap ${
                      item.trend === 'up' ? 'text-green-600' : item.trend === 'down' ? 'text-red-500' : 'text-accent-600'
                    }`}>
                      {item.trend === 'up' && <i className="ri-arrow-up-line text-[10px] mr-0.5"></i>}
                      {item.trend === 'down' && <i className="ri-arrow-down-line text-[10px] mr-0.5"></i>}
                      {item.change}
                    </span>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}